import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { orgapi,adminapi } from "../../ApiNames";
import { AnyARecord } from 'dns';

type Nullable<T> = T | null;

export const fetchdatasuccess = (data:any)=>({
    type : 'fetch_data_success',
    payload:data
})
export const fetchdocdatasuccess = (docview:any)=>({
    type : 'fetch_view_data_success',
    payload:docview,
});
export const fetchDataViewSuccess = (viewdata: any) => ({
    type: 'FETCH_VIEW_DATA_SUCCESS',
    payload: viewdata,
});
export const fetchdocdata = (docdata: any) => ({
    type: 'VIEW_DATA_SUCCESS',
    payload: docdata,
});
export const savedata = (datasave: any) => ({
    type: 'SAVE_DATA_SUCCESS',
    payload: datasave,
});
export const APPLY_DATA = (dataapply: any) => ({
    type: 'APPLY_DATA_SUCCESS',
    payload: dataapply,
});
export const RE_APPLYDATA = (datareapply: any) => ({
    type: 'REAPPLY_DATA_SUCCESS',
    payload: datareapply,
});
export const fetchsaveDataSuccess = (savedata: any) => ({
    type: 'FETCH_SAVE_DATA_SUCCESS',
    payload: savedata,
});
export const fetchchatDataSuccess = (chatdata: any) => ({
    type: 'FETCH_CHAT_DATA_SUCCESS',
    payload: chatdata,
});
export const fetchDataSuccessmsg = (msgdata: any) => ({
    type: 'FETCH_DATA_SUCCESS_MAG',
    payload: msgdata,
});
export const fetchdata = (uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {uid:uid};
            const apiname = orgapi.orgdocuments
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}
export const fetchviewdata = (uid:any,application_id:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {userid:uid,need:application_id};
            const apiname = orgapi.orgviewapplication
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataViewSuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    }
}

export const fetchviewDoc = ( application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { need:application_id,q:14};
            const apiname = adminapi.ad_donordocument;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdocdata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdocdata = (DocID:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            const payload = {did:DocID,q:4};
            const apiname = orgapi.orgdocview;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchdocdatasuccess(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const SAVEDATA = ( uid:any,application_id:any,description:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { userid:uid,need:application_id,description:description};
            const apiname = orgapi.orgsaveapp;
            const response = await LoginService.getData(apiname,payload)
            dispatch(savedata(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ApplyData = ( uid:any,application_id:any,description:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,need:application_id,description:description};
            const apiname = orgapi.orgapplyapp;
            const response = await LoginService.getData(apiname,payload)
            dispatch(APPLY_DATA(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ReApplyData = ( uid:any,application_id:any,description:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,need:application_id,description:description};
            const apiname = orgapi.orgapplyapp;
            const response = await LoginService.getData(apiname,payload)
            dispatch(RE_APPLYDATA(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchSaveData = (application_id:any,selectedCategories:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { need:application_id,ids:selectedCategories,userid:uid,q:2 };
            const apiname = orgapi.orgdocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchsaveDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchChatData = (uid:any,usertype:any,application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,usertype:usertype,need:application_id };
            const apiname = orgapi.orgchat;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchchatDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const addmsgdata = (uid:any,message:any,application_id:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { Userid:uid,message:message,need:application_id,q:1 };
            const apiname = orgapi.orgmessage;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchDataSuccessmsg(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
     
    };
   
};